import type { IRItemCard } from '~/presentation/reports/common/type';

import { ItemInfoSection } from '../../../GroupedSelectPopover';
import { InfoIcon } from '@shopify/polaris-icons';
import { Icon, Popover } from '@shopify/polaris';
import { WrapperAction } from './WrapperAction';
import { useState } from 'react';

interface ViewActionProps {
  info?: IRItemCard;
}

export const ViewAction: React.FC<ViewActionProps> = ({ info }) => {
  const [active, toggleActive] = useState(false);
  if (!info) return null;

  return (
    <Popover
      active={active}
      activator={
        <WrapperAction>
          <div
            onMouseEnter={() => toggleActive(true)}
            onMouseLeave={() => toggleActive(false)}
            onClick={(e) => e.stopPropagation()}
          >
            <Icon source={InfoIcon} />
          </div>
        </WrapperAction>
      }
      onClose={() => {
        toggleActive(false);
      }}
      fluidContent
      fullHeight
      preferredAlignment="right"
    >
      <div className="p-3 w-[270px]">
        <ItemInfoSection info={info} />
      </div>
    </Popover>
  );
};
